import React from 'react';
import {
  InvestmentsViewPicker,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Investments/InvestmentsViewPicker';

const InvestmentsView = (props) => {
  return <InvestmentsViewPicker {...props} />;
};

export default InvestmentsView;
